import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

import Title from "core/Components/Title";

type Props = {
    data: DescriptionWithRichText
};

const Header: React.FC<Props> = ({ data }) => {
    const theme: Theme = useTheme();
    const colourTheme = JSON.parse(data.theme);
    const { headerColour } = colourTheme;

    const headerStyle = css`
        color: ${headerColour};
        align-self: center;
        text-align: center;
        font-weight: ${theme.fonts.weights.bold};
        margin-bottom: 22px;
        
        ${headerColour && css`
            color: ${headerColour};
        `}
        
        ${theme.breakpoints.up("5xl")} {
            margin-bottom: 45px;
        }

        ${theme.breakpoints.between("3xl", "4xl")} {
            margin-bottom: 25px;
        }

        ${theme.breakpoints.only("xl")} {
            margin-bottom: 39px;
        }

        ${theme.breakpoints.down("md")} {
            margin-bottom: 35px;
        }

        ${theme.breakpoints.down("sm")} {
            margin-bottom: 20px;
        }
    `;

    return (
        <Title Tag={"h2"} css={headerStyle}>
            {data.header}
        </Title>
    );
}

export default Header;
